import React, { forwardRef } from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';

function checkboxIcon() {
    return (
        <svg
            className="MuiSvgIcon-root NeptuneCheckbox-checkedIcon"
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            role="presentation"
        >
            <path
                transform="rotate(45 12.839 8.293)"
                d="M9.046 16v-2h7V2h2v14h-9z"
            />
        </svg>
    );
}

const Checkbox = forwardRef((props, ref) => {
    const attrs = { ref };

    return (
        <MaterialCheckbox
            disableRipple
            color="default"
            checkedIcon={checkboxIcon()}
            icon={<span className="NeptuneCheckbox-icon" />}
            {...attrs}
            {...props}
        />
    );
});

Checkbox.displayName = 'NeptuneCheckbox';
Checkbox.propTypes = { ...MaterialCheckbox.propTypes };

export default Checkbox;
